export enum MXNotificationSystemNotifications {
    Connected = 1,
    Disconnected = 2,
    AuthFailed = 3,
    UserActivity = 4,
    AppActivity = 5,
    WsLog = 6,
}

export enum UserActionsEnum {
    ChatOpened = 1,
    ContactRead = 2,
    ChatClosed = 3,
    ChatMaximized = 4,
    ChatMinimized = 5,
    SearchedChatOpened = 6,
    EndSession = 7,
    RecentContactToggle = 8,
    UnreadChatCountSync = 9,
}
